import isEqual from 'lodash.isequal'
import React, { memo } from 'react'

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m22.97.08L.39,11.42c-.23.11-.38.34-.39.6-.01.25.12.5.33.63l5.29,3.26v7.4c0,.3.19.57.48.67.07.02.15.04.22.04.22,0,.43-.1.57-.28l3.62-4.81,8.11,4.99c.2.12.44.14.65.04.21-.09.36-.28.41-.51L23.99.84s0-.02,0-.02c.09-.57-.51-1-1.02-.74ZM6.29,14.66l-4.15-2.55L18.69,3.8,6.29,14.66Zm.74,6.53v-5.31l11.65-10.2c-.26.34-11.34,15.1-11.65,15.51Zm11.45.97l-7.13-4.39L22.04,3.55l-3.55,18.61Z" />
  </svg>
)

const Mail = memo(SvgComponent, isEqual)
export default Mail
